const PointerIcon = () => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_4272_12554" fill="white">
        <path d="M5.35105 7.50325C4.96359 8.16843 4.00134 8.16472 3.61901 7.49658L0.608163 2.23494C0.225833 1.5668 0.710163 0.735325 1.47996 0.738289L7.54209 0.761634C8.31189 0.764599 8.7898 1.59978 8.40233 2.26496L5.35105 7.50325Z" />
      </mask>
      <path
        d="M5.35105 7.50325C4.96359 8.16843 4.00134 8.16472 3.61901 7.49658L0.608163 2.23494C0.225833 1.5668 0.710163 0.735325 1.47996 0.738289L7.54209 0.761634C8.31189 0.764599 8.7898 1.59978 8.40233 2.26496L5.35105 7.50325Z"
        fill="#4F4F4F"
      />
      <path
        d="M7.54209 0.761634L7.54594 -0.238358L7.54209 0.761634ZM8.40233 2.26496L7.53824 1.76163L8.40233 2.26496ZM0.608163 2.23494L1.47611 1.73828L0.608163 2.23494ZM1.47996 0.738289L1.47611 1.73828L1.47996 0.738289ZM3.61901 7.49658L2.75107 7.99324L3.61901 7.49658ZM5.35105 7.50325L6.21514 8.00658L5.35105 7.50325ZM4.48696 6.99992L1.47611 1.73828L-0.259781 2.73161L2.75107 7.99324L4.48696 6.99992ZM1.47611 1.73828L7.53824 1.76163L7.54594 -0.238358L1.48381 -0.261703L1.47611 1.73828ZM7.53824 1.76163L4.48696 6.99992L6.21514 8.00658L9.26643 2.76829L7.53824 1.76163ZM7.53824 1.76163L7.53824 1.76163L9.26643 2.76829C10.0414 1.43793 9.08553 -0.232429 7.54594 -0.238358L7.53824 1.76163ZM1.47611 1.73828L1.47611 1.73828L1.48381 -0.261703C-0.0557816 -0.267632 -1.02444 1.39532 -0.259781 2.73161L1.47611 1.73828ZM2.75107 7.99324C3.51573 9.32953 5.44022 9.33694 6.21514 8.00658L4.48696 6.99992L4.48696 6.99992L2.75107 7.99324Z"
        fill="#9CD3D3"
        mask="url(#path-1-inside-1_4272_12554)"
      />
    </svg>
  );
};
export default PointerIcon;
